export default __webpack_public_path__ + "static/media/jerry1.e1a140e5.jpg";